import React, { useState } from "react";
import useStyles from "../../components/Common/styles";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toastr } from "../../components/Common/toastr";
import { Blade, BladeValidationDisplay, BladeTabPanel } from "../../components/Common/Blade";
import { TextField, Tab, Tabs, Grid, Typography, Button } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { useForm } from "react-hook-form";
import useProtectApi from "../../hooks/useProtectApi";
import { useFetchCurrency } from "../../hooks/useFetchEntity";
import { DeleteButton } from "../../components/Common/Buttons";

const CurrencyManage = () => {
	const [value, setValue] = React.useState(0);
	const [localCurrency] = useFetchCurrency();

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	function a11yProps(index) {
		return {
			id: `tab-${index}`,
			"aria-controls": `tabpanel-${index}`,
		};
	}
	return !localCurrency ? (
		<div></div>
	) : (
		<Blade>
			<Tabs
				value={value}
				onChange={handleChange}
				aria-label="user tabs"
				variant="fullWidth"
				indicatorColor="primary">
				<Tab label="Details" {...a11yProps(0)} />
				<Tab label="Remove" {...a11yProps(1)} />
			</Tabs>
			<BladeTabPanel value={value} index={0}>
				<CurrencyDetails currency={localCurrency} />
			</BladeTabPanel>
			<BladeTabPanel value={value} index={1}>
				<RemoveCurrency currency={localCurrency} />
			</BladeTabPanel>
		</Blade>
	);
};

const CurrencyDetails = ({ currency }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const renameCurrencyApi = useProtectApi("currency/rename");
	const { register, handleSubmit, errors } = useForm();
	const history = useHistory();

	const [isBusy, setIsBusy] = useState(false);
	const [apiErrors, setApiErrors] = useState();

	const onSubmit = async (data) => {
		var request = {
			id: currency.id,
			name: data.name,
		};

		const renameCurrency = () =>
			renameCurrencyApi.api().then((w) =>
				w
					.put(request)
					.badRequest((err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.error(409, (err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.json((json) => {
						var modifiedCurrency = {
							...request,
						};

						dispatch({
							type: "RENAME_CURRENCY",
							payload: modifiedCurrency,
						});

						return modifiedCurrency;
					})
					.then(() => toastr.success("Currenct details changed"))
					.then(() => closeDrawer())
					.catch((error) => {
						console.log(error);
						toastr.error("Unable to change Currency name.");
					})
					.finally(() => setIsBusy(false))
			);

		setIsBusy(true);
		renameCurrency();
	};

	const closeDrawer = () => {
		history.goBack();
	};

	return (
		<div>
			<form onSubmit={handleSubmit(onSubmit)}>
				<section>
					<TextField
						label="Name *"
						fullWidth
						name="name"
						autoFocus
						error={!!(errors && errors.name)}
						style={{ marginBottom: 16 }}
						autoComplete="off"
						inputRef={register({
							required: {
								value: true,
								message: "Name is required",
							},
							maxLength: {
								value: 255,
								message: "Name is too long",
							},
						})}
						inputProps={{
							"aria-label": "Name",
						}}
						helperText={errors && errors.name && errors.name.message}
						defaultValue={currency.name}
					/>
				</section>

				<div style={{ marginBottom: 12 }}>
					<Typography>Code: '{currency.code}'</Typography>
				</div>

				<div style={{ marginBottom: 12 }}>
					<Typography>Symbol: '{currency.symbol}'</Typography>
				</div>

				{!!apiErrors && <BladeValidationDisplay validationErrors={apiErrors} />}

				<div className={classes.drawerBladeToolbar}>
					<Button
						variant="contained"
						color="primary"
						size="medium"
						type="submit"
						className={classes.button}
						endIcon={<SaveIcon />}
						disabled={isBusy}>
						SAVE
					</Button>
				</div>
			</form>
		</div>
	);
};

const RemoveCurrency = ({ currency }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const removeCurrencyApi = useProtectApi("currency/delete");
	const [isBusy, setIsBusy] = useState(false);
	const [apiErrors, setApiErrors] = useState();

	const closeDrawer = () => {
		history.goBack();
	};

	const removeCurrencyClick = () => {
		var request = {
			Id: currency.id,
		};

		const apiDelete = () =>
			removeCurrencyApi.api().then((w) =>
				w
					.put(request)
					.badRequest((err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.error(409, (err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.res(() => {
						dispatch({
							type: "REMOVE_CURRENCY",
							payload: currency,
						});
					})
					.then(() => toastr.success("Currency removed"))
					.then(() => closeDrawer())
					.catch((error) => {
						console.log(error);
						toastr.error("Unable to remove Currency.");
					})
			);

		setIsBusy(true);
		apiDelete();
	};

	return (
		<div>
			<Typography>
				<p>Remove Currency '{currency.name}' from the application?</p>
				<p>If you do so this Currency will no longer be available.</p>
			</Typography>

			<div className={classes.drawerBladeToolbar}>
				<DeleteButton
					variant="outlined"
					color="primary"
					size="medium"
					onClick={() => removeCurrencyClick()}
					className={classes.button}
					disabled={isBusy}
					text="Remove"
				/>
			</div>

			{!!apiErrors && <BladeValidationDisplay validationErrors={apiErrors} />}
		</div>
	);
};

export default CurrencyManage;
